<template>
    <div class="security-details-recent-trades security-details-section">
        <h4>Recent Trades</h4>
        <p>Delayed by 20 minutes. Up to 25 of the latest trades shown.</p>
        <table class="data security-trades-table">
            <thead>
                <tr>
                    <th>Price ({{security.CurrencyIsoCode}})</th>
                    <th>Size</th>
                    <th>Currency</th>
                    <th>Time/Date</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in security.TradingData.RecentTrades" :key="index">
                    <td><strong>{{item.Price}}</strong></td>
                    <td>{{item.Size}}</td>
                    <td>{{security.CurrencyIsoCode}}</td>
                    <td>{{item.TradedAtDisplay}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    import { format, parseISO } from 'date-fns';
    export default {
        props: {
            theme: String,
            security: Object
        }
    };
</script>